// extracted by mini-css-extract-plugin
export default {"liner":"hBMHiI","lineWrap":"fhVXX9","line":"unNn8Z","content":"KkfoIR","mobile":"GTMQrj","percent":"jYPiKE"};